import React, { PureComponent as Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import ProductTitle from "../../PageProductDetails/Detail/ProductTitle";
import PriceTag from "../../PageProductDetails/Detail/Sizes/PriceTag";
import SizeInfo from "./SizeInfo";
import SneakerCondition from "./SneakerCondition";
import propTypes from "prop-types";
import { TextRupiah } from "../../Text";
import styled from "styled-components";

import { doFetchHighestOffer } from "../../../actions/offerAction";
import { getHandbagConditions } from "../../../actions/productAction";

class SneakerInfoContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      _highestOffer: 0
    };
  }

  componentDidMount() {
    if (this.props.offerPage === true) {
      this.props.doFetchHighestOffer(this.props.productId);
      this.props.getHandbagConditions(this.props.productId);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.offerPage === true) {
      const sizeId = this.props.location.state.size_id;
      const user_sell_id = this.props.location.state.id;
      const availables =
        this.props.dataOffer.highestOffer.data &&
        this.props.dataOffer.highestOffer.data.availables;
      const preOwned =
        this.props.dataOffer.highestOffer.data &&
        this.props.dataOffer.highestOffer.data.useds;
      const preOrder =
        this.props.dataOffer.highestOffer.data &&
        this.props.dataOffer.highestOffer.data.pre_orders;
      const {
        sneakers_condition,
        category,
        selectedSize
      } = this.props.location.state;

      //for sneakers and apparels
      if (
        prevProps.dataOffer.highestOffer.isFetch &&
        prevProps.dataOffer.highestOffer.isFetch !==
          this.props.dataOffer.highestOffer.isFetch
      ) {
        const { dataOffer } = this.props;

        if (dataOffer.highestOffer.status_code === 200) {
          //pre-owned only
          if (sneakers_condition === "BEKAS" && !selectedSize.pre_order) {
            const highestBidById = preOwned.find(
              item => item.id === user_sell_id
            );

            this.setState({
              _highestOffer: highestBidById.highest_bid
                ? highestBidById.highest_bid.amount
                : 0
            });
          }

          //brand new & bukan pre-order
          if (
            sneakers_condition === "BARU" &&
            !selectedSize.pre_order &&
            category !== "handbags"
          ) {
            const highestBidById = availables.find(
              item => item.id === user_sell_id
            );

            this.setState({
              _highestOffer: highestBidById.highest_bid
                ? highestBidById.highest_bid.amount
                : 0
              //  _highestOffer: 0
            });
          }

          //pre-order only (all condition)
          if (selectedSize.pre_order && category !== "handbags") {
            const highestBidById = preOrder.find(
              item => item.id === user_sell_id
            );

            this.setState({
              _highestOffer: highestBidById.highest_bid
                ? highestBidById.highest_bid.amount
                : 0
            });
          }
        }
      }
      // if(prevProps.dataOffer.highestOffer.isFetch&&prevProps.dataOffer.highestOffer.isFetch!==this.props.dataOffer.highestOffer.isFetch){
      //   const highestOfferAvailable = availables.filter((data) => {
      //     if(user_sell_id===undefined){
      //       return data.size_id == sizeId
      //     } else {
      //       return data.id == user_sell_id
      //     }
      //   })

      //   const highestOfferAvailablePreOwned = preOwned.filter((data) => {
      //     return data.id == user_sell_id
      //   })

      //   const highestOfferAvailablePreOrder = preOrder.filter((data) => {
      //     return data.id == user_sell_id
      //   })

      //   if(highestOfferAvailable.length>0){
      //     this.setState({
      //       _highestOffer: highestOfferAvailable[0].highest_bid!==null?highestOfferAvailable[0].highest_bid.amount:0
      //     })
      //   }

      //   if(highestOfferAvailablePreOrder.length>0){
      //     this.setState({
      //       _highestOffer: highestOfferAvailablePreOrder[0].highest_bid!=null?highestOfferAvailablePreOrder[0].highest_bid.amount: 0
      //     })
      //   }

      //   if(highestOfferAvailablePreOwned.length>0){
      //     this.setState({
      //       _highestOffer: highestOfferAvailablePreOwned[0].highest_bid!==null?highestOfferAvailablePreOwned[0].highest_bid.amount:0
      //     })
      //   }
      // }

      //for handbag
      if (
        prevProps.productCondition.isFetch &&
        prevProps.productCondition.isFetch !==
          this.props.productCondition.isFetch
      ) {
        if (this.props.productCondition.status_code === 200) {
          if (category === "handbags" || category === "lifestyles") {
            const { productCondition } = this.props;
            const highestBidById = productCondition.data.find(
              item => item.id === user_sell_id
            );

            this.setState({
              _highestOffer: highestBidById.highest_bid
                ? highestBidById.highest_bid.amount
                : 0
            });
          }
        }
      }
    }
  }

  _isVilla = () => {
    const DETERMINED_KEYWORD = "FILA";
    const { display_name } = this.props.product;

    if (!display_name) return;

    return display_name
      .toLowerCase()
      .includes(DETERMINED_KEYWORD.toLowerCase());
  };

  render() {
    if (this.props.product.id === undefined) return null;

    return (
      <div className="sneaker-info-container">
        <ProductTitle
          display_name={this.props.product.display_name}
          brands={
            this.props.product.product.brand_id !== null
              ? this.props.product.product.brand.flat
              : []
          }
          sku={this.props.product.SKU}
          colour={this.props.product.colour}
          type={this.props.product.type}
          dimension={this.props.product.dimension}
          release_date={this.props.product.release_date}
          retail_price={this.props.product.retail_price}
          currency={this.props.product.currency}
          isLogged={this.props.dataAuth.isLogged}
          userData={this.props.dataAuth.userdata}
          roleNotAlloweds={["unverified_user"]}
        />
        {this.props.offerPage? (
          <div>
            <Row>
              <Col>
                <Row className="price buy-now">
                  <Col className="price-col" sm={4} xs={5}>
                    <TitleWrapper>
                      <h4>Highest Offer</h4>
                      <h4>-</h4>
                    </TitleWrapper>
                  </Col>
                  <Col className="price-col" sm={8} xs={7}>
                    <PriceWrapper>
                      <h4>
                        <TextRupiah
                          color="red"
                          bold={true}
                          value={this.state._highestOffer}
                          prefix="IDR. "
                        />
                      </h4>
                    </PriceWrapper>
                  </Col>
                </Row>
              </Col>
            </Row>

            <SneakerCondition
              pre_order={this.props.sell ? this.props.sell.pre_order : null}
              sneaker_condition={
                this.props.history.location.state.sneakers_condition
              }
              box_condition={this.props.history.location.state.box_condition}
              sneaker_size={this.props.history.location.state.size}
              missing_accessories={
                this.props.history.location.state.missing_accessories
              }
              sneakers_defect={
                this.props.history.location.state.sneakers_defect
              }
              yellowing={this.props.history.location.state.yellowing}
              display_item={this.props.history.location.state.display_item}
              dataAvailableSize={this.props.dataAvailableSize}
              isVilla={this._isVilla()}
              defects={this.props.history.location.state.defects}
              category={this.props.history.location.state.category}
              hide_box_info={this.props.product.hide_box_info}
              isVintage={this.props.product.vintage}
              {...this.props}
            />
          </div>
        ) : this.props.showPrice ? (
          <div>
            <Row>
              <Col>
                <PriceTag
                  showInstallments
                  installments={this.props.installments}
                  asking_price={
                    this.props.sell.asking_price
                      ? this.props.sell.asking_price
                      : 0
                  }
                  total_subsidy={this.props.sell && this.props.sell.total_subsidy}
                />
              </Col>
            </Row>
          </div>
        ) : (
          <div>
            <Row>
              <Col>
                <PriceTag
                  showInstallments
                  installments={this.props.installments}
                  asking_price={this.props.sell.asking_price}
                  total_subsidy={this.props.sell && this.props.sell.total_subsidy}
                  invoice
                />
              </Col>
            </Row>
          </div>
        )}
        {this.props.offerPage? (
          ""
        ) : (
          <SneakerCondition
            pre_order={this.props.sell.pre_order}
            sneaker_condition={this.props.sell.sneakers_condition}
            box_condition={this.props.sell.box_condition}
            hide_box_info={this.props.product.hide_box_info}
            sneaker_size={this.props.sell.size}
            missing_accessories={this.props.sell.missing_accessories}
            dataAvailableSize={this.props.dataAvailableSize}
            sneakers_defect={this.props.sell.sneakers_defect}
            display_item={this.props.sell.display_item}
            yellowing={this.props.sell.yellowing}
            isVilla={this._isVilla()}
            defects={this.props.sell.defects}
            category={this.props.product.product.category.name}
            isVintage={this.props.product.vintage}
            {...this.props}
          />
        )}
      </div>
    );
  }
}

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  h4 {
    &:last-child{
      margin-left: 1rem;
    }
  }

  @media(max-width: 480px){
    h4 {
      &:first-child{
        margin-left: 15px;
      }
      &:last-child{
        margin-left: 1rem;
      }
    }
  }
`

const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  h4{
    margin-left: -2rem;
  }

  @media(max-width: 480px){
    h4 {
      margin-left: -1rem;
    }
  }
`

const mapStateToProps = state => {
  return {
    dataOffer: state.dataOffer,
    dataAuth: state.dataAuth,
    dataProductDetails: state.dataProduct.productDetails,
    productCondition: state.dataProduct.handbagCondition
  };
};

const mapDispatchToProps = dispatch => {
  return {
    doFetchHighestOffer: productId => dispatch(doFetchHighestOffer(productId)),
    getHandbagConditions: productId => dispatch(getHandbagConditions(productId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SneakerInfoContainer);

SneakerInfoContainer.propTypes = {
  product: propTypes.object.isRequired,
  sell: propTypes.object.isRequired,
  installments: propTypes.shape({
    isSubmit: propTypes.bool,
    data: propTypes.shape({
      installments: propTypes.array
    }),
    error: propTypes.object
  }),
  showPrice: propTypes.bool,
  offerPage: propTypes.bool
};
SneakerInfoContainer.defaultProps = {
  showPrice: true
};
